<script setup lang="js">
  import Table from "@/base-components/Table";
  import Lucide from "@/base-components/Lucide";
  import {formatSize} from "@/composables/utility.js";
  import moment from "moment-jalaali";
  const {traffics} = defineProps({traffics: {type: Array, required: []}})
  moment.loadPersian({usePersianDigits: true});
</script>

<template>
  <Table class="border-spacing-y-[10px] border-separate -mt-2">
    <Table.Thead>
      <Table.Tr>
        <Table.Th class="border-b-0 whitespace-nowrap">
          {{ $t("title.traffic") }}
        </Table.Th>
        <Table.Th class="text-center border-b-0 whitespace-nowrap">
          {{ $t("title.status") }}
        </Table.Th>
        <Table.Th class="text-center border-b-0 whitespace-nowrap">
          {{ $t("title.date") }}
        </Table.Th>
      </Table.Tr>
    </Table.Thead>
    <Table.Tbody>
      <Table.Tr v-for="traffic in traffics" :key="traffic.id" class="intro-x">
        <Table.Td
          class="first:rounded-l-md last:rounded-r-md bg-white border-b-0 dark:bg-darkmode-600 shadow-[20px_3px_20px_#0000000b]"
        >
          <a href="" class="font-medium whitespace-nowrap">
            {{ formatSize(traffic.unit, "mb", 0) }}
          </a>
          <div class="text-slate-500 text-xs whitespace-nowrap mt-0.5">-</div>
        </Table.Td>
        <Table.Td
          class="first:rounded-l-md last:rounded-r-md w-40 bg-white border-b-0 dark:bg-darkmode-600 shadow-[20px_3px_20px_#0000000b]"
        >
          <div
            :class="[
              'flex items-center justify-center',
              { 'text-success': !traffic.UsedAt },
              { 'text-danger': traffic.UsedAt },
            ]"
          >
            <Lucide icon="CheckSquare" class="w-4 h-4 mr-2" />
            {{ traffic.UsedAt ? $t("title.used") : $t("title.reserve") }}
          </div>
        </Table.Td>
        <Table.Td
          class="first:rounded-l-md last:rounded-r-md w-40 bg-white border-b-0 dark:bg-darkmode-600 shadow-[20px_3px_20px_#0000000b]"
        >
          <div
            :class="[
              'flex items-center justify-center',
              { 'text-success': !traffic.UsedAt },
              { 'text-danger': traffic.UsedAt },
            ]"
          >
            <Lucide icon="CheckSquare" class="w-4 h-4 mr-2" />
            {{
              moment(!traffic.UsedAt ? traffic.createdAt : traffic.UsedAt)
                .locale("fa")
                .format("jYYYY/jMM/jDD HH:mm:ss")
            }}
          </div>
        </Table.Td>
      </Table.Tr>
    </Table.Tbody>
  </Table>
</template>

<style scoped></style>
